import React, { useState } from "react";
import axios from "axios";
import AdminSidebar from "../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../component/AdminComp/AdminTopbar";
import { baseurl } from "../../Baseurl"; // Ensure baseurl is defined
import Swal from "sweetalert2"; // Import SweetAlert2
import { Link } from "react-router-dom";

const AdminBannersHalf = () => {
  const [bannerImage, setBannerImage] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [heading, setHeading] = useState(""); // Heading state
  const [actionUrl, setActionUrl] = useState(""); // Action URL state

  // Handle drag-and-drop
  const handleDrop = (event) => {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    handleFile(file);
  };

  // Handle file selection
  const handleFileInput = (event) => {
    const file = event.target.files[0];
    handleFile(file);
  };

  // Handle file selection and validation
  const handleFile = (file) => {
    if (file && file.type.startsWith("image/")) {
      setBannerImage(URL.createObjectURL(file));
      setSelectedFile(file);
    } else {
      Swal.fire("Invalid file", "Please upload a valid image file.", "error");
    }
  };

  // Handle form submission
  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!selectedFile) {
      Swal.fire("No File Selected", "Please upload an image first.", "warning");
      return;
    }

    // Prepare FormData
    const formData = new FormData();
    formData.append("banner", selectedFile);
    formData.append("heading", heading);
    formData.append("action_url", actionUrl);
    formData.append("banner_type", "half_banner");

    // Log the data being sent
    console.log("Sending Data:", {
      banner: selectedFile.name,
      heading,
      action_url: actionUrl,
    });

    try {
      const response = await axios.post(`${baseurl}upload-banner-half`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      Swal.fire("Success", "Banner uploaded successfully!", "success").then(() => {
        window.location.reload(); // This will reload the page
      });
      
    } catch (error) {
      Swal.fire("Upload Failed", "Something went wrong. Try again!", "error");
      console.error("Upload error:", error);
    }
  };

  return (
    <div className="App" style={{ display: "flex" }}>
      <AdminSidebar />

      {/* Content area */}
      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <AdminTopbar />
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h4 className="text-start">Website Half Banners</h4>
          </div>
 

          {/* Drop Area */}
          <div className="row  p-2">

<div className="col-md-8 bg-white">
    {/* Heading Input */}
    <div className="mb-3 text-start">
            <label className="form-label">Half Banners Heading</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Banner Heading"
              value={heading}
              onChange={(e) => setHeading(e.target.value)}
            />
          </div>

          {/* Action URL Input */}
          <div className="mb-3 text-start">
            <label className="form-label">Half Banners Action URL</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Banner Action URL"
              value={actionUrl}
              onChange={(e) => setActionUrl(e.target.value)}
            />
          </div>

            <div
              className="drop-area"
              onDrop={handleDrop}
              onDragOver={(e) => e.preventDefault()}
              onClick={() => document.getElementById("fileInput").click()}
            >
              {bannerImage ? (
                <img src={bannerImage} alt="Banner Preview" className="preview-image" />
              ) : (
                <p>Drag & drop an image here, or click to select</p>
              )}
            </div>

            {/* Hidden File Input */}
            <input
              type="file"
              id="fileInput"
              accept="image/*"
              className="banimg"
              onChange={handleFileInput}
              style={{ display: "none" }}
            />

<div  className="text-end mb-3">
<button className="btn btn-primary mt-3" onClick={handleSubmit}>
            Upload Banner
          </button>
</div>




</div>
            
          </div>

          {/* Upload Button */}
          
        </div>
      </div>
    </div>
  );
};

export default AdminBannersHalf;
